import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import FirebaseRegisterForm from './FirebaseRegisterForm';

const FirebaseRegister = ({
  page,
  onRegisterFirebaseUser=f=>f,
  onNext,
  content,
  requiredFields
}) => {
  const thisPage = P.FIREBASE_REGISTER_PAGE

  return (
    <div>
      <Redirector this_page={thisPage} page={page}/>
      <FormHeader title={content.pages.register.title}/>
        <FirebaseRegisterForm
          onRegisterFirebaseUser={onRegisterFirebaseUser}
          onNext={onNext}
          requiredFields={requiredFields}
        /> 
    </div>
  );
};

FirebaseRegister.propTypes = {
  onRegisterUser: PropTypes.func,
  onRegisterFirebaseUser: PropTypes.func,
  onNext: PropTypes.func,
  page: PropTypes.string,
  content: PropTypes.object,
  marketing_referrers: PropTypes.array,
  country_code: PropTypes.string,
  environment: PropTypes.string
};

export default injectIntl(FirebaseRegister);
